
import Vue from "vue";

export default Vue.extend({
	methods: {
		onDrop(e: any) {
			e.stopPropagation();
			e.preventDefault();
			var files = e.dataTransfer.files;
			this.$emit("input", files[0]);
		},
		onInput(event: Event) {
			let input = event.target as HTMLInputElement;
			if (!input.files) return;
			if (input.files.length == 0) return;
			for (let i = 0; i < input.files.length; i++) {
				let item = input.files.item(i);
				if (!item) continue;
				this.$emit("input", item);
			}
		},
		labelClick() {
			let input = this.$refs.input as HTMLInputElement;
			input.click();
		},
	}
});
